import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from './_shared/components/sidebar/sidebar.component';
import { NavbarComponent } from '../_shared/components/navbar/navbar.component';

@Component({
  selector: 'app-driver-management',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, NavbarComponent],
  templateUrl: './driver-management.component.html',
  styleUrl: './driver-management.component.scss',
})
export class DriverManagementComponent {}
